const diyLoanDetailsEventCategory = "DIY_CR";

export const sellNowClicked = {
    eventCategory: "DIY_N_Price",
    eventAction: "Sell Now button clicked on price screen"
};

export const directOcbAcceptPrice = {
    event: "direct_ocb_accept_price",
    eventAction: "Direct OCB accept price button clicked",
    eventCategory: "DIY_DOCB"
};

export const diyLoanCreditReportViewed = {
    eventCategory: diyLoanDetailsEventCategory,
    event: "Credit_report_screen_view",
    eventAction: "Credit report screen view"
};

export const diyLoanCreditMobileErrorViewed = {
    eventCategory: diyLoanDetailsEventCategory,
    event: "Credit_mobile_error_screen",
    eventAction: "Credit mobile error screen"
};
